import { SunlightSeason } from './sunlight-season.model';

export interface SunlightSimulationConfig {
  latitude: number;
  longitude: number;
  minHour: number;
  maxHour: number;
  defaultHour: number;
  modelUrl: string;
  // Rotation around Y, degrees, to align the model's forward face to true north.
  modelNorthOffsetDeg?: number;
  modelOffsetX?: number;
  modelOffsetY?: number;
  modelOffsetZ?: number;
  modelScale?: number;
  brightenTextures?: boolean;
  // Single date locks the simulation to it and hides the season picker (see seasons.length
  // check in the slider template) - add more entries to offer more dates.
  seasons: SunlightSeason[];
}

export const SUNLIGHT_SIMULATION_DEFAULT_CONFIG: SunlightSimulationConfig = {
  latitude: 47.3769,
  longitude: 8.5417,
  minHour: 4,
  maxHour: 22,
  defaultHour: 11,
  modelUrl: '',
  modelNorthOffsetDeg: 0,
  modelOffsetX: 0,
  modelOffsetY: 0,
  modelOffsetZ: 0,
  modelScale: 1,
  brightenTextures: false,
  seasons: [
    { id: 'summer', label: 'Summer', month: 6, day: 21, utcOffsetHours: 2 }, // CEST
  ],
};
